import {AxiosError} from 'axios';
import {toastError} from './toast';
import {goURL} from "@/helpers/router";
import i18n from "@/locales/i18n";

const apiErrorMessage = (error: AxiosError) => {
    if (typeof error === 'string') {
        return error;
    }
    const response = error && error.response;

    const isArrayBuffer = response?.request?.responseType === 'arraybuffer' && response?.data?.toString() === '[object ArrayBuffer]';

    if (isArrayBuffer) {
        try {
            response.data = JSON.parse(Buffer.from(response.data).toString('utf8'));
        } catch (error) {
            // ignore JSON parse error
        }
    }

    try {
        if (response && typeof response === 'object') {
            const message = (response.data && (response.data.message || response.data.errorMessage || response.data.errors)) || response.data || response;
            return message || 'Oops something went wrong.';
        }

        return typeof response === 'string' ? response : error.message;
    } catch (error) {
        return error.message;
    }
};

export const errorHandler = (error: AxiosError): void => {
    console.error('errorHandler', error);
    toastError(apiErrorMessage(error));
};


export const checkErrorResponse = (error: any): void => {
    if (error?.response && error.response.code === 401) {
        toastError(i18n.t("common.no_auth"));

        // redirect
        goURL('/auth/login');
    } else {
        if (error.response?.message) {
            toastError(error.response.message);
        } else {
            toastError(i18n.t("common.general_error"));
        }
    }
}